var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "",
        centered: true,
        footer: null,
        maskClosable: false,
        dialogClass: "global-campaign-post-modal-class",
        closable: false,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "modal-con", class: [_vm.lang] }, [
        _c("div", { staticClass: "post-title" }, [
          _vm._v(_vm._s(_vm.$t("postModalTitle"))),
        ]),
        _c("div", { staticClass: "people-box" }, [
          _c("div", { staticClass: "people-left" }, [
            _c("div", { staticClass: "people-item" }, [
              _c("div", { staticClass: "people-item-label" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabel1")) + "："),
              ]),
              _c("div", { staticClass: "people-item-txt" }, [_vm._v("33")]),
            ]),
            _c("div", { staticClass: "people-item" }, [
              _c("div", { staticClass: "people-item-label" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabel2")) + "："),
              ]),
              _c("div", { staticClass: "people-item-txt" }, [_vm._v("30")]),
            ]),
            _c("div", { staticClass: "people-item" }, [
              _c("div", { staticClass: "people-item-label" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabel3")) + "："),
              ]),
              _c("div", { staticClass: "people-item-txt" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabelTxt"))),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "people-icon" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/post-modal-icon@2x.png"),
                alt: "",
              },
            }),
            _c("div", { staticClass: "icon-txt" }, [
              _vm._v(_vm._s(_vm.$t("postModalIconTxt"))),
            ]),
          ]),
          _c("div", { staticClass: "people-right" }, [
            _c("div", { staticClass: "people-item" }, [
              _c("div", { staticClass: "people-item-label" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabel1")) + "："),
              ]),
              _c("div", { staticClass: "people-item-txt" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabelTxt2"))),
              ]),
            ]),
            _c("div", { staticClass: "people-item" }, [
              _c("div", { staticClass: "people-item-label" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabel2")) + "："),
              ]),
              _c("div", { staticClass: "people-item-txt" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabelTxt2"))),
              ]),
            ]),
            _c("div", { staticClass: "people-item" }, [
              _c("div", { staticClass: "people-item-label" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabel3")) + "："),
              ]),
              _c("div", { staticClass: "people-item-txt" }, [
                _vm._v(_vm._s(_vm.$t("postModalLabelTxt1"))),
              ]),
            ]),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "post-con beauty-scroll",
            class: {
              post_con_more: _vm.isShowMoreCon,
            },
          },
          [
            _c("div", {
              staticClass: "con-txt",
              class: [_vm.lang],
              domProps: { innerHTML: _vm._s(_vm.modal_con) },
            }),
            !_vm.isShowMoreCon
              ? _c("div", { staticClass: "con-hidden-btn" }, [
                  _c(
                    "div",
                    {
                      staticClass: "hidden-btn-txt",
                      class: [_vm.lang],
                      on: { click: _vm.showMoreCon },
                    },
                    [_vm._v(_vm._s(_vm.$t("postModalAllBtn")))]
                  ),
                ])
              : _vm._e(),
          ]
        ),
        _c("div", { staticClass: "btn-box" }, [
          _c(
            "div",
            {
              staticClass: "btn",
              class: [_vm.lang],
              on: {
                click: function ($event) {
                  return _vm.saveCompaign("1")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("postModalBtnTxt")))]
          ),
        ]),
        _c("div", { staticClass: "btn-txt-box" }, [
          _c(
            "span",
            {
              class: [_vm.lang],
              on: {
                click: function ($event) {
                  return _vm.saveCompaign("0")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("postModalBtnTxt1")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }